import React from 'react';
// eslint-disable-next-line
import { addNotification } from '../action/notificationAction';
// eslint-disable-next-line
import Routes from './Routes';
import Home from './Pages/Home';
// eslint-disable-next-line
import processStore from '../store/processStore';

import PageHoc from '../HoC/PageHoC';
import userStore from '../store/userStore';
import { Config } from '../config';

class UserLogin extends React.Component {

    componentDidMount() {
        if (Config.env !== "dev") {
            // this now shows the home page again
            // if (userStore.user.privilege === "ADMIN") {
            //     this.props.history.push("/admin");
            // }
        }
    }
    render() {
        return (
            <div>
                <Home history={this.props.history} />
            </div>

        );

    }

}
export default PageHoc(UserLogin);



// WEBPACK FOOTER //
// ./src/components/UserLogin.js